class QuoteModal extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('#QuoteForm');
    this.iframeTarget = this.querySelector('#QuoteFormTarget');
    this.successMessage = this.querySelector('#QuoteForm-Success');
    this.errorMessage = this.querySelector('#QuoteForm-Error');
    this.closeBtn = this.querySelector('#QuoteModal-Close');
    this.backdrop = document.querySelector('#QuoteModalBackdrop');
    this.productInput = this.querySelector('#QuoteForm-Product');
    this.skuInput = this.querySelector('#QuoteForm-SKU');
    this.variantInput = this.querySelector('#QuoteForm-Variant');
    this.productImage = this.querySelector('.quote-modal__product-image');
    this.productDisplayTitle = this.querySelector('.quote-modal__product-details .product-title');
    this.productDisplayMeta = this.querySelector('.quote-modal__product-details .product-meta');

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }
    if (this.backdrop) {
      this.backdrop.addEventListener('click', this.hide.bind(this));
    }
    this.addEventListener('keyup', function(event) {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  connectedCallback() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.onVariantChange.bind(this)
      );
    }
    if (this.form) {
      this.form.setAttribute('target', 'QuoteFormTarget');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }

  show(productTitle, productSku, variantTitle) {
    this.setProductInfo(productTitle, productSku, variantTitle);
    if (this.successMessage) this.successMessage.hidden = true;
    if (this.errorMessage) this.errorMessage.hidden = true;
    if (this.form) {
      this.form.hidden = false;
      this.form.reset();
    }
    this.setProductInfo(productTitle, productSku, variantTitle);

    document.body.classList.add('overflow-hidden');
    if (this.backdrop) this.backdrop.classList.add('is-active');
    this.setAttribute('open', '');
    requestAnimationFrame(function () {
      var firstInput = this.querySelector('input:not([type="hidden"]):not([readonly])');
      if (firstInput) firstInput.focus();
    }.bind(this));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    if (this.backdrop) this.backdrop.classList.remove('is-active');
    this.removeAttribute('open');
  }

  setProductInfo(productTitle, productSku, variantTitle) {
    if (this.productInput) this.productInput.value = productTitle || '';
    if (this.skuInput) this.skuInput.value = productSku || '';
    if (this.variantInput) this.variantInput.value = variantTitle || '';
    if (this.productDisplayTitle) this.productDisplayTitle.textContent = productTitle || '';

    var metaParts = [];
    if (productSku) metaParts.push('SKU: ' + productSku);
    if (variantTitle) metaParts.push(variantTitle);
    if (this.productDisplayMeta && metaParts.length > 0) {
      this.productDisplayMeta.textContent = metaParts.join(' | ');
    }
  }

  onVariantChange(event) {
    var data = event.data;
    if (!data || !data.variant) return;
    var variant = data.variant;
    var currentTitle = this.productInput ? this.productInput.value : '';
    var sku = variant.sku || '';
    var variantTitle = variant.title !== 'Default Title' ? variant.title : '';
    this.setProductInfo(currentTitle, sku, variantTitle);

    if (variant.featured_image && this.productImage) {
      this.productImage.src = variant.featured_image.src;
      this.productImage.alt = currentTitle;
    }

    var triggerBtn = document.querySelector('[data-quote-trigger]');
    if (triggerBtn) {
      triggerBtn.dataset.productSku = sku;
      triggerBtn.dataset.variantTitle = variantTitle;
    }
  }

  onSubmit() {
    var self = this;
    var submitBtn = this.form.querySelector('.button');

    if (submitBtn) {
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;
    }
    if (this.errorMessage) this.errorMessage.hidden = true;

    var onLoad = function () {
      try {
        var iframeDoc = self.iframeTarget.contentDocument || self.iframeTarget.contentWindow.document;
        var hasError = iframeDoc.querySelector('.form-status--error') || iframeDoc.querySelector('.errors');
        if (hasError) {
          if (self.errorMessage) self.errorMessage.hidden = false;
        } else {
          if (self.form) self.form.hidden = true;
          if (self.successMessage) self.successMessage.hidden = false;
        }
      } catch (e) {
        if (self.form) self.form.hidden = true;
        if (self.successMessage) self.successMessage.hidden = false;
      }

      if (submitBtn) {
        submitBtn.classList.remove('loading');
        submitBtn.disabled = false;
      }
      self.iframeTarget.removeEventListener('load', onLoad);
    };

    this.iframeTarget.addEventListener('load', onLoad);
  }
}

customElements.define('quote-modal', QuoteModal);
